import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import FormikWithHoney, { WithHoneypot } from '@spa/components/forms/formik-with-honey/formikWithHoney.component';
import React, { ReactElement, useState } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { Schema } from 'yup';
import type { SessionsData } from '@spa/lib/auth/sessionTypes';
import { TitleCode } from '@spa/lib/converters/convertCustomerTitles';
import ToyCatalogFormComponent from '@spa/components/forms/toy-catalog-form/toy-catalog-form.component';
import { ToyCatalogFormFields } from '@spa/components/toy-catalog/toyCatalogTypes';
import getAuthSessionUserId from '@spa/lib/auth/getAuthSessionUserId';
import logger from '@spa/lib/logger';
import selectCountryCode from '@spa/lib/store/settings/selectors/selectCountryCode';
import submitToyCatalogSubscriptionAction from '@spa/lib/actions/forms/submitToyCatalogSubscriptionAction';
import toyCatalogValidationSchema from '@spa/components/forms/toy-catalog-form/toyCatalogValidationSchema';
import useHoneypotToken from '@spa/components/forms/formik-with-honey/useHoneypotToken';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useNextAuthOrSession from '@spa/lib/react/hooks/useNextAuthOrSession';
import { useSelector } from 'react-redux';
export interface Props {}
enum FORM_STATUS {
  FAILED = 'FAILED',
  INITIAL = 'INITIAL',
  SUBMITTING = 'SUBMITTING',
  SUBMITTED = 'SUBMITTED',
}
function ToyCatalogComponent() {
  const $ = _c(17);
  const country = useSelector(selectCountryCode);
  const honeypotToken = useHoneypotToken();
  const {
    authSession
  } = useNextAuthOrSession();
  let t0;
  if ($[0] !== authSession) {
    t0 = getAuthSessionUserId(authSession);
    $[0] = authSession;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const userId = t0;
  const [formStatus, setFormStatus] = useState(FORM_STATUS.INITIAL);
  const {
    formatMessage
  } = useNamespacedIntl("toy-catalog");
  const {
    formatMessage: formatMessageForForm
  } = useNamespacedIntl("forms");
  let t1;
  if ($[2] !== country || $[3] !== formatMessageForForm) {
    t1 = toyCatalogValidationSchema(country, formatMessageForForm);
    $[2] = country;
    $[3] = formatMessageForForm;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const validationSchema = t1;
  let t2;
  if ($[5] !== country || $[6] !== userId) {
    t2 = {
      salutation: TitleCode.EMPTY,
      firstName: "",
      lastName: "",
      email: "",
      street: "",
      houseNumber: "",
      postalCode: "",
      city: "",
      countryCode: country,
      userId
    };
    $[5] = country;
    $[6] = userId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const initialFormValues = t2;
  let t3;
  if ($[8] !== honeypotToken) {
    t3 = async values => {
      setFormStatus(FORM_STATUS.SUBMITTING);
      ;
      try {
        const result = await submitToyCatalogSubscriptionAction("submitToyCatalogSubscriptionAction", {
          formData: values,
          honeypotToken
        });
        if (result.success) {
          setFormStatus(FORM_STATUS.SUBMITTED);
        } else {
          setFormStatus(FORM_STATUS.FAILED);
        }
      } catch (t4) {
        const error = t4;
        logger.error(error, "Error submitting toy catalog form:");
        setFormStatus(FORM_STATUS.FAILED);
      }
    };
    $[8] = honeypotToken;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleSubmit = t3;
  let t4;
  if ($[10] !== formStatus || $[11] !== formatMessage || $[12] !== handleSubmit || $[13] !== honeypotToken || $[14] !== initialFormValues || $[15] !== validationSchema) {
    t4 = <>{formStatus === FORM_STATUS.SUBMITTED ? <AlertComponent alertType={AlertType.SUCCESS} content={formatMessage("submitSuccess")} /> : <FormikWithHoney initialValues={initialFormValues} onSubmit={handleSubmit} validationSchema={validationSchema} validateOnBlur={true} honeypotToken={honeypotToken}>{t5 => {
          const {
            errors,
            touched,
            values: values_0
          } = t5;
          return <ToyCatalogFormComponent errors={errors} submitError={formStatus === FORM_STATUS.FAILED ? formatMessage("submitError") : undefined} isSubmitting={formStatus === FORM_STATUS.SUBMITTING} touched={touched} values={values_0} />;
        }}</FormikWithHoney>}</>;
    $[10] = formStatus;
    $[11] = formatMessage;
    $[12] = handleSubmit;
    $[13] = honeypotToken;
    $[14] = initialFormValues;
    $[15] = validationSchema;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
export default ToyCatalogComponent;